const PbxxRecord = require('../../pbxx_record')

module.exports = class PulseAggregates extends PbxxRecord {
  static get class_name() {
    return 'PulseAggregates'
  }
}
